<div class="dms-new-folder-model">
    <!-- <div class="modal-title mb-8">
        <h1 mat-dialog-title class="m-0">{{ data.LanguageKey | translate }}</h1>
    </div> -->
    <div class="delta-dialog-toolbar h-64 pl-24 pr-24 pt-20 pb-20" fxLayout="row" fxLayoutAlign="space-between center">
		<span class="title">{{data.LanguageKey|translate}}</span>
		<mat-icon class="close cursor-pointer" matTooltip="{{ 'CLOSE_DIALOG' | translate }}" matTooltipPosition="above"
			(click)="dialogRef.close()">close</mat-icon>
	</div>
    <!-- <div class="model-subtitle mb-16">
        <span>{{ "APP_PLATFORM_DOCUMENT_MANAGER.DMS_FOLDER_NAME_SUBTITLE" | translate }}</span>
    </div> -->
    <div mat-dialog-content class="m-24 p-0">
        <mat-form-field appearance="outline" class="w-100-p">
            <mat-label>{{ "APP_PLATFORM_DOCUMENT_MANAGER.DMS_FOLDER_NAME" | translate }}</mat-label>
            <input
                #folderName="ngModel"
                matInput
                cdkFocusInitial
                placeholder="{{ 'APP_PLATFORM_DOCUMENT_MANAGER.DMS_FOLDER_NAME' | translate }}"
                (keydown)="onKeydown($event)"
                (ngModelChange)="onChangeEvent($event)"
                [(ngModel)]="data.name"
                maxlength="60"
            />
        </mat-form-field>

    </div>
    <mat-divider></mat-divider>
    <div mat-dialog-actions fxLayout="row" fxLayoutAlign="space-between center" class="mx-24 my-12">
        <button mat-button (click)="onNoClick()" class="delta-button">
            {{ "APP_PLATFORM_DOCUMENT_MANAGER.CANCEL" | translate }}
        </button>
        <button
            *ngIf="data.title === 'New Folder'"
            mat-raised-button
            color="primary"
            [mat-dialog-close]="data.name"
            (click)="onCreate()"
            class=""
            [disabled]="isDisable"
        >
            {{ "APP_PLATFORM_DOCUMENT_MANAGER.CREATE" | translate }}
        </button>
        <button
            *ngIf="data.title === 'Rename Folder' || data.title === 'Rename File'"
            mat-raised-button
            color="primary"
            [mat-dialog-close]="data.name"
            class="delta-button"
            [disabled]="isDisable"
        >
            {{ "APP_PLATFORM_DOCUMENT_MANAGER.DMS_RENAME" | translate }}
        </button>
    </div>
</div>
